'use strict';

function CompanyUserPermissionService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/users/:userId/permissions/:permissionId', {}, {
    'query': { method: 'GET', isArray: false },
    'update': { method:'PUT' }
  });
}

angular.module('dokiv')
  .factory('CompanyUserPermissionService', ['$resource', 'config', CompanyUserPermissionService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/users/CompanyUserPermissionService.js
// module id = 67
// module chunks = 0